import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import CustomDatePicker from './CustomDatePicker';

const AgeVerificationModal = ({ 
  onVerification, 
  defaultSimpleMode = false,
  allowModeSwitch = true
}) => {
  const [birthDate, setBirthDate] = useState('');
  const [age, setAge] = useState(null);
  const [show, setShow] = useState(false);
  const [simpleMode, setSimpleMode] = useState(defaultSimpleMode);

  useEffect(() => {
    const isOver18 = localStorage.getItem('over18');
    if (!isOver18) {
      setShow(true);
    }
    document.body.setAttribute("data-bs-theme", "dark")
  }, []);

  const calculateAge = (birthDateString) => {
    const today = new Date();
    const birthDateObj = new Date(birthDateString);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
      age--;
    }
    
    return age;
  };

  const handleDateChange = (date) => {
    setBirthDate(date);
    setAge(calculateAge(date));
  };

  const handleEnter = () => {
    localStorage.setItem('over18', 'true');
    setShow(false);
    onVerification();
  };

  const handleLeave = () => {
    window.location.href = 'https://www.google.com';
  };

  const handleSimpleVerification = () => {
    setAge(18);
    handleEnter();
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      data-bs-theme="dark"
    >
      <Modal.Header>
        <Modal.Title>Age Verification Required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This website contains adult content. Please verify your age to continue.</p>
        
        {allowModeSwitch && (
          <div className="mb-3 text-center">
            <Button 
              variant="outline-primary" 
              size="sm"
              onClick={() => setSimpleMode(!simpleMode)}
            >
              Switch to {simpleMode ? 'Calendar' : 'Simple'} Mode
            </Button>
          </div>
        )}

        {simpleMode ? (
          <div className="text-center">
            <p>Are you 18 years or older?</p>
            <div className="d-flex justify-content-center gap-2">
              <Button 
                variant="success" 
                onClick={handleSimpleVerification}
              >
                Yes, I am 18+
              </Button>
              <Button 
                variant="danger" 
                onClick={handleLeave}
              >
                No, I am under 18
              </Button>
            </div>
          </div>
        ) : (
          <>
            <CustomDatePicker onChange={handleDateChange} />
            {age !== null && (
              <div className="mt-3">
                {age < 18 ? (
                  <div className="text-danger">
                    Sorry, you must be at least 18 years old to access this website.
                    <Button 
                      variant="danger" 
                      className="d-block w-100 mt-2"
                      onClick={handleLeave}
                    >
                      Leave Website
                    </Button>
                  </div>
                ) : (
                  <div className="text-success">
                    Age verified: {age} years old
                    <Button 
                      variant="success" 
                      className="d-block w-100 mt-2"
                      onClick={handleEnter}
                    >
                      Enter Website
                    </Button>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AgeVerificationModal; 